import { ScreeningResultsTypes } from '../../features/RenterInvite/ScreeningResultsTypes';
import { RentCoverageTypes, SecurityDepositTypes } from '../../constants/CoverageType';

export enum RenterInviteType {
  SMBInviteOldCustomCoverage = 'SMB_Invite_old_custom_coverage',
  SMBInviteNewLimitedSdr = 'SMB_Invite_new_limited_sdr',
}

export interface Renter {
  approvalStatus?: ScreeningResultsTypes | '';
  address: Address;
  apartmentNumber: string;
  leaseStart: Date;
  leaseEnd: Date;
  grossMonthlyRent: number;
  prepaidRent?: number;
  freeRent?: number;
  applicantEmails: { value: string }[];
  rentCoverage: RentCoverageTypes;
  monthsOfCoverage?: number;
  securityDepositCoverage: SecurityDepositTypes;
  securityDepositReplacementAmount?: number;
  customCoverage?: boolean;
  includeDepositCoverage?: boolean;
  renterInviteType?: RenterInviteType;
}

export interface Address {
  monolith_building_id: number;
  source?: string | null;
  property_id?: string;
  property_alpha_id?: string;
  address_id?: string;
  line1?: string;
  city?: string;
  state?: string;
  postal_code?: string;
}

export enum CoverageType {
  RentCoverage = 'rentCoverage',
  SecurityDepositCoverage = 'securityDepositCoverage',
}
